export const LOYALTY_HUB_SECTIONS = {
  STAR_REWARDS: 'star-rewards',
  LOYALLIST: 'loyallist',
  GAMIFIED_OFFERS: 'gamified-offers',
  OFFERS: 'offers',
  TRIPLE_POINTS: 'triple-points',
  BENEFITS: 'benefits',
  PERKS: 'perks',
  EXCLUSION: 'exclusion',
};

const SECTION_ELEMENT_IDS = {
  [LOYALTY_HUB_SECTIONS.STAR_REWARDS]: 'loyalty-hub-summary-section',
  [LOYALTY_HUB_SECTIONS.LOYALLIST]: 'loyalty-hub-summary-section',
  [LOYALTY_HUB_SECTIONS.GAMIFIED_OFFERS]: 'gamified-offers-section',
  [LOYALTY_HUB_SECTIONS.OFFERS]: 'offers-section',
  [LOYALTY_HUB_SECTIONS.TRIPLE_POINTS]: 'triple-points-section',
  [LOYALTY_HUB_SECTIONS.BENEFITS]: 'benefits-section',
  [LOYALTY_HUB_SECTIONS.PERKS]: 'perks-section',
  [LOYALTY_HUB_SECTIONS.EXCLUSION]: 'exclusion-section',
};

const SHARED_LOYALTY_HUB_SECTION_KEYS = [
  LOYALTY_HUB_SECTIONS.GAMIFIED_OFFERS,
  LOYALTY_HUB_SECTIONS.OFFERS,
  LOYALTY_HUB_SECTIONS.TRIPLE_POINTS,
  LOYALTY_HUB_SECTIONS.BENEFITS,
  LOYALTY_HUB_SECTIONS.PERKS,
  LOYALTY_HUB_SECTIONS.EXCLUSION,
];

const BRAND_HUB_SECTION_KEYS = {
  mcom: LOYALTY_HUB_SECTIONS.STAR_REWARDS,
  bcom: LOYALTY_HUB_SECTIONS.LOYALLIST,
};
const SCROLL_TOP_OFFSET_PX = 40;

export function normalizeLoyaltyHubSection(section) {
  const value = Array.isArray(section) ? section[0] : section;
  return value?.toLowerCase?.()?.trim?.() || '';
}

function scrollElementIntoView(elementId, behavior) {
  const element = document.getElementById(elementId);

  if (!element) {
    return false;
  }

  const top = element.getBoundingClientRect().top + window.scrollY - SCROLL_TOP_OFFSET_PX;

  window.scrollTo({
    top: Math.max(0, top),
    behavior,
  });

  return true;
}

export function isValidLoyaltyHubSection(section, brand) {
  const normalizedSection = normalizeLoyaltyHubSection(section);

  if (SHARED_LOYALTY_HUB_SECTION_KEYS.includes(normalizedSection)) {
    return true;
  }

  return normalizedSection === BRAND_HUB_SECTION_KEYS[brand];
}

export function getLoyaltyHubSectionElementId(section) {
  return SECTION_ELEMENT_IDS[normalizeLoyaltyHubSection(section)];
}

export function scrollToLoyaltyHubSection(section, options = {}) {
  const { maxAttempts = 20, intervalMs = 100, behavior = 'smooth', followUpDelays = [] } = options;
  const elementId = getLoyaltyHubSectionElementId(section);

  if (!elementId) {
    return Promise.resolve(false);
  }

  const scheduleFollowUpScrolls = () => {
    followUpDelays.forEach((delay) => {
      setTimeout(() => scrollElementIntoView(elementId, behavior), delay);
    });
  };

  return new Promise((resolve) => {
    let attempts = 0;

    const tryScroll = () => {
      if (scrollElementIntoView(elementId, behavior)) {
        scheduleFollowUpScrolls();
        resolve(true);
        return;
      }

      attempts += 1;
      if (attempts >= maxAttempts) {
        resolve(false);
        return;
      }

      setTimeout(tryScroll, intervalMs);
    };

    tryScroll();
  });
}
